import { Breadcrumb, Card, Tabs } from "client/CommonComponents"
import './ApprovalDashboard.scss';

const ApprovalDashboard = ({breadcrumlist, approvalManagementTab, handleLinkClick, tabItem}:any) => {
    return(
        <div className='Approval-Dashboard mt-1'>
            <div className='breadcrumb-toolbar'>
                <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="ApprovalDashboard_Default_Breadcrumb" /></div>
            </div>
            <Card data-attribute="ApprovalDashboard_Default_Card">
                <Tabs 
                    tabItems={tabItem} 
                    className='approval-dashboard-tab'
                    selectedKey={approvalManagementTab ?? 'approval-hierarchy'}
                    handleLinkClick={handleLinkClick} 
                 data-attribute="ApprovalDashboard_Default_Tabs" />
            </Card>
        </div>
    )
}

export default ApprovalDashboard